/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Dispatch } from 'redux';
import { getLocationTypes } from '../../services/locations';
import { getLocationTypesStart, getLocationTypesSuccess, getLocationTypesFailure } from './locationTypesActionCreator';

export const fetchLocationTypes = async (dispatch: Dispatch) => {
  dispatch(getLocationTypesStart());
  try {
    const locationTypes = await getLocationTypes();
    dispatch(getLocationTypesSuccess(locationTypes));
  } catch (error: any) {
    dispatch(getLocationTypesFailure(`Error in fetching location types: ${error.response?.data?.message || error.message}`));
  }
};
